const o = {
  Terms: "TERMS",
  PersonalData: "PERSONAL_DATA",
  CommunicationAuthorization: "COMMUNICATION_AUTHORIZATION"
};
export {
  o as H
};
//# sourceMappingURL=RegistrationPatchRequest-ee880d05.mjs.map
